import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingSpinner } from '../components';
import { OpsType } from '../types';
import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  requireOps?: OpsType;
  // Permission key required to view the route (deep-link guard).
  requirePermission?: string;
}

export function ProtectedRoute({
  children,
  requireOps,
  requirePermission,
}: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, hasOpsAccess, hasPermission } =
    useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireOps && !hasOpsAccess(requireOps)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requirePermission && !hasPermission(requirePermission, requireOps)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}
